module.exports = "<div class=\"notFound\">\n    <h1>Page Not Found</h1>\n    <p>Sorry, but the page you were trying to view does not exist.</p>    \n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.html
// module id = ./src/app/components/not-found/not-found.component.html
// module chunks = main